export class UploadManualPOD {
  public isWithProofFile: boolean
  public photoURL: string[]

  constructor(isWithProofFile: boolean, photoURL: string[]) {
    this.isWithProofFile = isWithProofFile
    this.photoURL = photoURL
  }
}
